import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PricingLegend from "../components/PricingLegend";
import Seo from "../components/Seo";

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo
        title="About"
        description="TerminalValue.io is a manually-reviewed, community-sourced index of investing tools. Submissions are vetted by a human."
        path="/about"
      />
      <Header />
      <main className="max-w-3xl mx-auto px-4 py-8">
        <h1 className="text-xl font-bold border-b border-black pb-2">{">"}_ about</h1>
        <div className="mt-4 text-[14px] leading-relaxed text-[#222] space-y-4">
          <p>
            <span className="font-bold">TerminalValue.io</span> is the investing tools index.
          </p>
          <p className="text-[13px] text-[#444]">
            This is a <span className="text-black">community-sourced directory</span>. Submissions come
            from the community and are manually reviewed before listing.
            Spotted something wrong? <Link to="/contact" className="tv-link">Send a correction →</Link>
          </p>
          <p>
            Every submission is reviewed before it&apos;s listed. Community upvotes surface the most useful tools.
          </p>
          <h2 className="text-[15px] font-bold pt-2">{">"} how it works</h2>
          <ol className="list-decimal pl-5 space-y-1">
            <li>You submit a tool with one-sentence description + one Key Feature.</li>
            <li>A human reviewer approves or rejects it (typically within 48h).</li>
            <li>Approved tools appear in the index and accept community upvotes.</li>
          </ol>
          <h2 id="pricing" className="text-[15px] font-bold pt-2">{">"} pricing tiers</h2>
          <p className="text-[13px] text-[#444]">
            Each tool shows a price tag (right-justified next to its name). Single tier
            (e.g. <span className="font-bold">$$</span>) reflects the entry paid plan;
            ranges (e.g. <span className="font-bold">FREE-$$</span>) mean the tool has both a usable
            free tier and paid plans.
          </p>
          <PricingLegend className="mt-2" />

          <p className="pt-4">
            <Link to="/submit" className="tv-btn tv-btn-primary">[+] Submit a tool</Link>{" "}
            <Link to="/" className="tv-btn">[← back to index]</Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
